import React from 'react';
import { Section } from './Section';
import { Check } from 'lucide-react';
export function Benefits() {
  const benefits = ['Reducirás la inflamación y la hinchazón posparto de forma natural', 'Recuperarás tu energía sin depender del café para sobrevivir el día', 'Dejarás de sentirte culpable por necesitar tiempo para ti', 'Reconectarás con tu identidad como mujer, no solo como mamá', 'Sanarás emocionalmente el proceso posparto que nadie te explicó', 'Dormirás mejor y te despertarás con más calma y claridad mental', 'Serás la mejor versión de ti para tu bebé y para ti misma'];
  return <Section data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl text-center mb-12 font-serif" data-id="element-3">
          Lo que RENACIDA hará por ti
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-x-12 md:gap-y-8" data-id="element-4">
          {benefits.map((benefit, index) => <div key={index} className={`flex items-start gap-4 ${index === 6 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-5">
              <div className="bg-sage/10 p-1.5 rounded-full flex-shrink-0 mt-1" data-id="element-6">
                <Check className="w-5 h-5 text-sage" data-id="element-7" />
              </div>
              <p className="text-lg text-brown-dark leading-relaxed" data-id="element-8">
                {benefit}
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}